import { Button, Flex, Link, Text, Center } from "@chakra-ui/react";

import { BANNER_DATA } from "@constants/banner";
import useBanner from "@hooks/useBanner";

const Banner = () => {
  const { showBanner } = useBanner();
  return (
    <>
      {showBanner ? (
        <Center
          w="100%"
          bg="#075A5A"
          fontSize={{ base: "12px", md: "14px" }}
          pos="relative"
          top="0"
          zIndex={7}
          p="8px"
          px={{ base: "16px", lg: "68px" }}
        >
          <Flex
            color="#FFF"
            fontWeight="500"
            lineHeight="140%"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            gap={{ base: "8px", md: "16px" }}
            w="100%"
          >
            <Text
              textAlign="left"
              dangerouslySetInnerHTML={{
                __html: BANNER_DATA.text,
              }}
            />
            {BANNER_DATA.cta_text && BANNER_DATA.cta_link ? (
              <Link
                isExternal
                href={BANNER_DATA.cta_link}
                minW="75px"
                _hover={{
                  textDecoration: "none",
                }}
              >
                <Button
                  p={{ base: "6px", md: "6px 12px" }}
                  bg="#FFF"
                  borderRadius="6px"
                  textDecor="none"
                  h="24px"
                >
                  <Text
                    fontSize="10px"
                    fontWeight="600"
                    lineHeight="12px"
                    // textTransform="uppercase"
                    // borderBottom="1px dashed"
                    borderColor="textPrimary"
                  >
                    {BANNER_DATA.cta_text}
                  </Text>
                </Button>
              </Link>
            ) : null}
          </Flex>
        </Center>
      ) : null}
    </>
  );
};

export default Banner;
